import React, { useState, ChangeEvent } from 'react';
import { HexColorPicker } from 'react-colorful';
import TextField from './TextField';

interface ColorPickerFieldProps {
  id: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  disabled?: boolean;
}

const ColorPickerField: React.FC<ColorPickerFieldProps> = ({
  id,
  value,
  onChange,
  disabled = false,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleColorChange = (color: string) => {
    const e = {
      target: {
        id,
        value: color,
        type: 'colorpicker'
      }
    } as ChangeEvent<HTMLInputElement>;
    onChange(e);
  };

  return (
    <div className="relative">
      <div className="flex items-center gap-2">
        <TextField
          id={id}
          type="text"
          value={value || ''}
          onChange={onChange}
          disabled={disabled}
          onClick={() => setShowColorPicker(true)}
        />
        <div
          className="w-8 h-8 border border-gray-300 rounded cursor-pointer flex-shrink-0"
          style={{ backgroundColor: value || '#ffffff' }}
          onClick={() => setShowColorPicker(true)}
        />
      </div>
      {showColorPicker && (
        <div className="absolute z-10 left-0 mt-2">
          <div
            className="fixed inset-0"
            onClick={() => setShowColorPicker(false)}
          />
          <div className="relative">
            <HexColorPicker
              color={value || '#ffffff'}
              onChange={handleColorChange}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ColorPickerField;